import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
@Injectable()
export class localStorageService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {

  }
  setItem(data) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(data.key, data.value)
    }
  }
  getItem(item) {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(item)
    }
    return null;
  }
  clear() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear()
    }
  }
}


